"use client"

import { useState } from "react"
import Container from "../../components/Container/Container"
import Modal from "../../components/Modal/Modal"
import ScrollReveal from "../../components/ScrollReveal/ScrollReveal"
import "./Gallery.css"

const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null)

  const galleryImages = [
    {
      id: 1,
      src: "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      alt: "Restaurant interior",
      category: "interior",
    },
    {
      id: 2,
      src: "https://images.unsplash.com/photo-1424847651672-bf20a4b0982b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      alt: "Fine dining setup",
      category: "dining",
    },
    {
      id: 3,
      src: "https://images.unsplash.com/photo-1578474846511-04ba529f0b88?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      alt: "Chef preparing food",
      category: "kitchen",
    },
    {
      id: 4,
      src: "https://images.unsplash.com/photo-1551218808-94e220e084d2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      alt: "Signature dish",
      category: "food",
    },
    {
      id: 5,
      src: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      alt: "Restaurant ambiance",
      category: "interior",
    },
    {
      id: 6,
      src: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      alt: "Elegant dining room",
      category: "dining",
    },
  ]

  return (
    <div className="gallery-page">
      <section className="gallery-hero">
        <Container>
          <div className="gallery-hero-content">
            <h1 className="gallery-title">Gallery</h1>
            <p className="gallery-subtitle">Experience the ambiance and artistry of Katchit</p>
          </div>
        </Container>
      </section>

      <section className="gallery-content">
        <Container>
          <div className="gallery-grid">
            {galleryImages.map((image, index) => (
              <ScrollReveal key={image.id} delay={index * 100}>
                <div className="gallery-item" onClick={() => setSelectedImage(image)}>
                  <img src={image.src || "/placeholder.svg"} alt={image.alt} />
                  <div className="gallery-overlay">
                    <div className="gallery-overlay-content">
                      <span className="gallery-category">{image.category}</span>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </Container>
      </section>

      {selectedImage && (
        <Modal onClose={() => setSelectedImage(null)}>
          <img src={selectedImage.src || "/placeholder.svg"} alt={selectedImage.alt} className="modal-image" />
        </Modal>
      )}
    </div>
  )
}

export default GalleryPage
